<template>
  <div class="popup-background flex-center" @click.self="$emit('click')">
    <slot />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.popup-background {
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 99999;
  background: var(--popup-background-color);
  top: 0;
  left: 0;
}
</style>
